import React from 'react';
import Icon from '../Icon/Icon';

const flipCard = ( props ) => {
	let side2 = null;
	if( props.side2 ) {
		side2 = {
			__html: props.side2.replace( /<p>/g, '<p class="card-text">' )
		};
	}
	
	let iconProps = {
		icon: props.icon,
		className: 'card-thumbnail',
		title: props.side1
	}
	
	let cardClass = 'FlipCard';
	if( props.className ) {
		// cardClass += ' flip-' + props.className;
		
		if( props.className.indexOf( 'bg-gradient' ) > -1 ) {
			iconProps.gradient = props.className.replace( 'bg-gradient', '' ).trim();
		}
	}
	
	let side1Class = 'side-1';
	if( props.side1class ) {
		side1Class += ' flip-' + props.side1class;
	}
	else if( props.className ) {
		side1Class += ' flip-' + props.className;
	}
	
	let side2Class = 'side-2';
	if( props.side2class ) {
		side2Class += ' flip-' + props.side2class;
	}
	else if( props.className ) {
		side2Class += ' flip-' + props.className;
	}
	
	return (
		<div className={ cardClass }>
			<div className="flipper">
				<div className={ side1Class }>
					<div className="card-content">
						<Icon { ...iconProps } />
						<p className="card-text">{ props.side1 }</p>
					</div>
					<div className="card-backdrop" />
				</div>
				
				<div className={ side2Class }>
					<div className="card-content" dangerouslySetInnerHTML={ side2 } />
					<div className="card-backdrop" />
				</div>
				
			</div>
		</div>
	);
};

export default flipCard;



// WEBPACK FOOTER //
// ./src/components/FlipCards/FlipCard.js